import { Box } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import FilterBar from './filterBar';

function AlwaysOn() {
  const iframeRef = useRef(null);
  const { company } = useSelector(state => state.company);
  const adjustIframeHeight = () => {
    const iframe = iframeRef.current;
    if (iframe) {
      try {
        iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
      } catch (error) {
        console.error('Error adjusting iframe height:', error.message);
      }
    }
  };
  
  const handleSrc = () => {
    let companyId = company.id;
    let src = '';

    switch (companyId) {
      case 18:
        src = 'https://app.powerbi.com/view?r=eyJrIjoiNDY3OWQ3M2QtMmI4Yi00ZjA4LTgyMmMtYTgxMzg0ZTUyYmI4IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9&pageName=ReportSection1eb665f5555cb118d20d';
        break;
      case 20:
        src = 'https://app.powerbi.com/view?r=eyJrIjoiOWUwNWNiZTMtODI0Ny00NWZhLThjM2EtYzgzNTI5MTZiYzk1IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9&pageName=ReportSection1eb665f5555cb118d20d';
        break;
      case 135:
        src = 'https://app.powerbi.com/view?r=eyJrIjoiOWUyNzhmYTctMTU5MS00ZGJmLTllZGQtZDVjZjMyMmM5OWJhIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
        break;
      case 140:
        src = 'https://app.powerbi.com/view?r=eyJrIjoiOWUyNzhmYTctMTU5MS00ZGJmLTllZGQtZDVjZjMyMmM5OWJhIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';
        break;
      default:
        src = 'https://app.powerbi.com/view?r=eyJrIjoiNDY3OWQ3M2QtMmI4Yi00ZjA4LTgyMmMtYTgxMzg0ZTUyYmI4IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9&pageName=ReportSection1eb665f5555cb118d20d';
        break;
    }
    return src;
  };
  useEffect(() => {
    adjustIframeHeight();
  }, [company.id]);
  return (
    <>
     <FilterBar />
     <Box className={'bg-white border-softer mt-4'} sx={{ height: '100vh' }}>
        <iframe
          title="New Yescarta Updating 1"
          src={handleSrc()}
          allowFullScreen="true"
          style={{
            height: '100%',
            width: '100%',
            border: 'none',
          }}
          ref={iframeRef}
          onLoad={adjustIframeHeight}
        />

      </Box>
    </>
      
  )
}

export default AlwaysOn;